import {
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
} from '_core/types';

export const API_DOMAIN: EndPointsNames = 'ApiAccount';
export const ENDPOINT_API_PATH = 'v1/members/bigdata/questions/validate';
export const ENTITY_NAME = 'validateBigDataQuestionResponse';
const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_CREDENTIALS';
const URL_POSTMAN =
  'https://smiles-sa.postman.co/workspace/1aa3f7db-730f-4a9e-8904-3201cc3d9669/api/80efeca4-b161-4017-ad01-ac0b4aa25090?version=fa75da42-085c-4706-9004-37e1cb711046&tab=overview';

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
  },
  {
    code: '11',
    message: 'Não validado.',
    bussinessErrorVariant: 'notValid',
  },
  {
    code: '204',
    message: 'Questionario expirado',
    bussinessErrorVariant: 'quizExpired',
  },
  {
    code: '307',
    message: 'Questionario ja foi respondido.',
    bussinessErrorVariant: 'quizAnswered',
  },
];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
  ENTITY_NAME,
};
